import React from 'react';

const SectionBlock = ({ stroke, ...props }) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="#3E3E40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="none"
      d="M19.5 13.9059H4.5C4.08579 13.9059 3.75 14.2417 3.75 14.6559V18.4059C3.75 18.8201 4.08579 19.1559 4.5 19.1559H19.5C19.9142 19.1559 20.25 18.8201 20.25 18.4059V14.6559C20.25 14.2417 19.9142 13.9059 19.5 13.9059Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="none"
      d="M19.5 5.65591H4.5C4.08579 5.65591 3.75 5.9917 3.75 6.40591V10.1559C3.75 10.5701 4.08579 10.9059 4.5 10.9059H19.5C19.9142 10.9059 20.25 10.5701 20.25 10.1559V6.40591C20.25 5.9917 19.9142 5.65591 19.5 5.65591Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SectionBlock;
